// extracted by mini-css-extract-plugin
export default {"link":"yA-z","disabled":"zA-z"};